import { getTranslation } from "@/utils";
import { Usage, GroupedUsages } from "@/interfaces";

export const groupUsagesByType = (usages: Usage[]): GroupedUsages => {
  return usages.reduce((groups: GroupedUsages, usage: Usage) => {
    const type = usage.type;
    if (!groups[type]) {
      groups[type] = [];
    }
    groups[type].push(usage);
    return groups;
  }, {});
};

export const getTypeLabels = () => ({
  filter: getTranslation(
    "filters-tree.modal.deletion-prevention.filters",
    "Filters",
  ),
  auto_filter: getTranslation(
    "filters-tree.modal.deletion-prevention.auto-filters",
    "Auto Filters",
  ),
  dashboard: getTranslation(
    "filters-tree.modal.deletion-prevention.dashboards",
    "Dashboards",
  ),
  report: getTranslation(
    "filters-tree.modal.deletion-prevention.reports",
    "Reports",
  ),
  field_dependency: getTranslation(
    "filters-tree.modal.deletion-prevention.fields",
    "Fields",
  ),
  cross_filter: getTranslation(
    "filters-tree.modal.deletion-prevention.cross-filter",
    "Criteria in Cross Filter",
  ),
});

export const renderUsageGroup = (
  type: string,
  usages: Usage[],
  typeLabels: ReturnType<typeof getTypeLabels>,
  styles: any,
) => {
  return (
    <div key={type} className={styles.deletionPreventionUsageGroup}>
      <div className={styles.deletionPreventionUsageGroupTitle}>
        {typeLabels[type as keyof typeof typeLabels] || type}:
      </div>
      <div>
        {usages.map((usage, index) => (
          <span key={index}>
            {usage.url ? (
              <a
                href={usage.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.deletionPreventionUsageLink}
              >
                {usage.name}
              </a>
            ) : (
              <span className={styles.deletionPreventionUsageText}>
                {usage.name}
              </span>
            )}
            {index < usages.length - 1 && <span>, </span>}
          </span>
        ))}
      </div>
    </div>
  );
};
